import { LOCALE_ID, Provider } from '@angular/core';
import { TranslatorService } from '../../services/translator';

export class Locale extends String {
  constructor(private readonly translatorService: TranslatorService) {
    super();
  }

  toString(): string {
    return this.translatorService.getCurrentLang().getValue();
  }

  valueOf(): string {
    return this.toString();
  }
}

export const LocaleProvider: Provider = {
  provide: LOCALE_ID,
  useClass: Locale,
  deps: [TranslatorService],
};
